export enum QuoteRequestStatusEnum {
  CONFIRMED = "CONFIRMED",
  REJECTED = "REJECTED",
  PENDING = "PENDING",
  PENDING_WINDOW = "PENDING_WINDOW",
  EXPIRED = "EXPIRED",
  ACCEPTED = "ACCEPTED",
  FAILED = "FAILED"
}
